import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
// import { LinkContainer } from "react-router-bootstrap"

import { 
  Row, Col, Panel, Glyphicon, Image,
  FormGroup, ControlLabel, FormControl, Button
} from "react-bootstrap"

import { fromJS, Map } from "immutable"
import ip from "ip"

import * as actionCreators from "../actions"
import logo from "./logo-black.png"

const newCredentials = fromJS({
  username: "",
  password: "",
  ip: ip.address(),
})

class Login extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    from: PropTypes.string
  }

  state = {
    credentials: newCredentials,
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.actions.login(this.state.credentials)

    const { from } = this.props.location.state || { from: { pathname: "/orders" } }
    if (this.props.auth.get("isAuthenticated")) {
      return <Redirect to={from} />
    }
      
  }

  handleChange = e => {
    const { name, value } = e.target
    this.setState((prev, props) => ({ credentials: prev.credentials.set(name, value) }))
  }

  handleCancel = e => {
    this.setState({ credentials: newCredentials })
  }

  isAuthenticated = () => {
    // return false
    return this.props.auth.get("isAuthenticated")
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/orders" } }

    if (this.isAuthenticated()) {
      return <Redirect to={from} />
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <Col xs={4} xsOffset={4} style={{ marginTop: "100px" }}>
          <Panel
            header={
              <Row>
                <Col xs={6}>
                  <Image src={logo} responsive />
                </Col>
              </Row>
            }
            footer={
              <Col>
                <Button bsSize="small" bsStyle="danger" onClick={this.handleCancel}>
                  <Glyphicon glyph="remove" /> Clear
                </Button>
                <Button className="pull-right" type="submit" bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
                  <Glyphicon glyph="ok" /> Login
                </Button>
              </Col>
            }>
            <FormGroup>
              <ControlLabel>Username</ControlLabel>
              <FormControl name="username" placeholder="Username"
                value={this.state.credentials.get("username")}
                onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Password</ControlLabel>
              <FormControl type="password" name="password" placeholder="Password"
                value={this.state.credentials.get("password")}
                onChange={this.handleChange} />
            </FormGroup>
          </Panel>
        </Col>
      </form>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  auth: state.get("auth") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js